export default "__VITE_ASSET__9c4a3e11__"